(function () {
  // Filters the product grid entirely client-side by matching each
  // grid item's data-product-tags against the clicked tab's tag.
  // Deliberately doesn't use Shopify's native ?filter.p.tag= URL
  // filtering / collection.filters — with only a handful of products,
  // there's no need for a server round-trip, and it sidesteps two
  // real problems that came up trying to use the native system: the
  // filter index can lag behind a product's tags changing, and the
  // exact query-param format Shopify expects isn't something worth
  // guessing at when a client-side show/hide is simpler and instant.

  function applyFilter(tag) {
    document.querySelectorAll('[data-product-tags]').forEach(function (item) {
      if (!tag) {
        item.hidden = false;
        return;
      }
      var tags = item.dataset.productTags.split(',').map(function (t) {
        return t.trim();
      });
      item.hidden = tags.indexOf(tag) === -1;
    });
  }

  function setActiveTab(tab) {
    document.querySelectorAll('[data-collection-tab]').forEach(function (t) {
      t.classList.toggle('is-active', t === tab);
    });
  }

  // Native CSS position: sticky doesn't hold for this bar (confirmed
  // by testing — something in its original section wrapper's
  // ancestor chain establishes its own containing block instead of
  // the viewport). This replicates sticky's actual behavior by hand:
  // the bar sits in its natural spot (right below the real site
  // header) until you scroll past that point, then switches to fixed
  // at the true top — taking over the header's spot — and switches
  // back once you scroll back above it. Moving both bars to <body>
  // is still needed so "fixed" anchors to the viewport once pinned.
  function initSticky() {
    var header = document.querySelector('.shopify-section-group-header-group');
    var tabs = document.querySelector('[data-collection-tabs]');
    var sort = document.querySelector('.facets-wrapper.page-width');
    if (!header || !tabs) return;

    if (tabs.parentElement !== document.body) document.body.appendChild(tabs);
    if (sort && sort.parentElement !== document.body) document.body.appendChild(sort);

    var naturalTop = 0;

    function measure() {
      // Measure the real header directly (its bottom edge, in
      // document coordinates) rather than an indirect placeholder —
      // this is the actual value that matters: where the bar should
      // sit until you've scrolled past the header. Set as a custom
      // property (not a direct .style.top) so the CSS can still add
      // its own offset on top for the sort bar, which needs to sit
      // in the same row as the tabs on desktop but stacked in a
      // second row on mobile.
      //
      // Dawn's real header is itself position: sticky with a
      // scroll-direction hide/show behavior (.shopify-section-header-
      // hidden slides it up via a negative top). getBoundingClientRect()
      // only reflects the header's true resting position while
      // scrollY is 0 — once scrolled, it reports wherever the sticky/
      // hidden animation currently has it, and rect.bottom + scrollY
      // stops being a stable document coordinate at all. On mobile,
      // scrolling itself fires resize events (the browser address bar
      // collapsing), which re-triggers this via the resize listener
      // below — if that happens mid-scroll, it was capturing a
      // corrupted, scroll-dependent value and pinning the bar to it,
      // which is what "gets stuck in the middle of the page" was.
      // Only trust a measurement taken at the top of the page.
      if (window.scrollY > 2) {
        updatePosition();
        return;
      }
      var rect = header.getBoundingClientRect();
      var measured = rect.bottom + window.scrollY;
      // A header that hasn't finished laying out yet (fonts/images
      // not loaded) could momentarily measure as ~0 — guard against
      // ever pinning the bar over a header that's actually there.
      if (measured > 0) {
        naturalTop = measured;
        document.documentElement.style.setProperty('--collection-tabs-natural-top', naturalTop + 'px');
      }
      updatePosition();
    }

    function updatePosition() {
      var pinned = window.scrollY >= naturalTop;
      tabs.classList.toggle('is-pinned', pinned);
      if (sort) sort.classList.toggle('is-pinned', pinned);
    }

    measure();
    // Re-measure after everything (fonts, images) has actually
    // finished loading, in case the initial measurement ran before
    // the header reached its final height.
    window.addEventListener('load', measure);
    setTimeout(measure, 500);
    setTimeout(measure, 1500);
    window.addEventListener('scroll', updatePosition, { passive: true });
    window.addEventListener('resize', measure);
  }

  function init() {
    initSticky();

    var tabs = document.querySelectorAll('[data-collection-tab]');
    if (!tabs.length) return;

    var params = new URLSearchParams(window.location.search);
    var initialTag = params.get('tab') || '';
    if (initialTag) {
      applyFilter(initialTag);
      tabs.forEach(function (tab) {
        if (tab.dataset.tag === initialTag) setActiveTab(tab);
      });
    }

    tabs.forEach(function (tab) {
      if (tab.dataset.bound) return;
      tab.dataset.bound = 'true';
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        var tag = tab.dataset.tag || '';
        applyFilter(tag);
        setActiveTab(tab);
        var url = tag ? window.location.pathname + '?tab=' + encodeURIComponent(tag) : window.location.pathname;
        history.pushState({ tab: tag }, '', url);
      });
    });
  }

  window.addEventListener('popstate', function () {
    var params = new URLSearchParams(window.location.search);
    var tag = params.get('tab') || '';
    applyFilter(tag);
    document.querySelectorAll('[data-collection-tab]').forEach(function (tab) {
      if (tab.dataset.tag === tag) setActiveTab(tab);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
